import { push } from 'connected-react-router';

import { generateProposalReport } from 'common/api/v1/proposals';
import { showReponseErrorsAsAlert } from 'common/utils/helpers';

import {
    GENERATE_PROPOSAL,
    GENERATE_PROPOSAL_FAILURE,
    GENERATE_PROPOSAL_SUCCESS,
} from '../actionTypes';
import { actions } from '../reducer';

export default (proposalId) => (dispatch) => {
    dispatch(actions[GENERATE_PROPOSAL]());

    generateProposalReport({ proposal: proposalId })
        .then(() => {
            dispatch(actions[GENERATE_PROPOSAL_SUCCESS]());
            dispatch(push(`/panel-layout/preview/${proposalId}`));
        })
        .catch((error) => {
            dispatch(
                actions[GENERATE_PROPOSAL_FAILURE](
                    error?.response?.data?.errors,
                ),
            );
            showReponseErrorsAsAlert(dispatch, error.response);
        });
};
